exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line[data-v-72934df6]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lines[data-v-72934df6]{display:-webkit-box;word-break:break-all;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:var(--row);-webkit-box-orient:vertical}\n", ""]);

// exports
